export const usersSubscriptionGroupCurrentDayStatsSubscriptionGroupId =
  "/users/subscription_group_current_day_stats/:subscription_group_id";
